import { render, staticRenderFns } from "./EditPersonEmergencyContactDialog.vue?vue&type=template&id=6d14cf61&scoped=true&"
import script from "./EditPersonEmergencyContactDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonEmergencyContactDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d14cf61",
  null
  
)

export default component.exports